import vars from '../helpers';
import AOS from "aos";
import headerHome from "../components/header-home";
import homeFooter from "../components/home-footer";
import animation from "../modules/animation";
import showMore from "../components/showMore";

function init(container) {
	/*gsap.timeline()
		.from($(container).find('.home__item'), {
			autoAlpha: 0,
			clearProps: 'all',
			stagger: 0.3,
			onStart: () => {
				$(container).find('.home__item').removeClass('is-hide');
			},
		});*/

	window.addEventListener('load', () => {
		AOS.init({
			offset: 1,
			once: true,
		});
	});

	headerHome.init();
	homeFooter.init();
	animation.init();
	showMore.init();
	initApps();
	$(window).on('scroll', () => {
		const scroll = document.documentElement.scrollTop;
		headerHome.scroll(scroll);
	});
}

function destroy(container) {
	$(container).find('.category-item').off('.home');
	$(container).find('.home__image').off('.home');
	headerHome.destroy()
}

export default {
	init,
	destroy,
};
